var _style, _path, _path2, _polygon, _path3, _polygon2, _path4, _polygon3, _polygon4, _circle, _circle2, _circle3, _circle4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNetworkAnalysis(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;stroke:#000000;stroke-width:8;stroke-linecap:round;stroke-linejoin:round;stroke-dasharray:12,14;}\n\t.st1{stroke:#000000;stroke-width:6;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10;}\n\t.st2{fill:#8C1515;stroke:#8C1515;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st3{fill:#2094E8;stroke:#2094E8;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st4{fill:#56BF46;stroke:#56BF46;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n\t.st5{fill:#F9C002;stroke:#F9C002;stroke-width:2;stroke-linecap:round;stroke-linejoin:round;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M41,277.6c56.7-40.4,69.8-80.4,56.1-124.1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M67.8,310c154.2-38.8,222.4-22.7,271.2,16.7"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "353.8,339.4 327.4,330.8 338.9,326.7 341.1,314.7 "
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M312.7,132.4c-79.5,36-188.9,114.4-228.3,143.3"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "68.5,287.4 83,263.6 84.4,275.7 95.5,280.6 "
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M427.3,310.8c48.5-106.8,28.1-149.7-4.5-170.5"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "405.7,130.7 433.2,134.2 422.8,140.4 422.9,152.5 "
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "89.6,135.2 109.1,155.1 97.1,153.4 89.6,163 "
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 68.5,
    cy: 90.1,
    r: 42.4
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 425.4,
    cy: 395.5,
    r: 84.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    className: "st4",
    cx: 35.2,
    cy: 310.8,
    r: 33.2
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 354.2,
    cy: 102.2,
    r: 51.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkAnalysis);
export default __webpack_public_path__ + "static/media/NetworkAnalysis.1de44586762a0be3e5ef9cf53add8471.svg";
export { ForwardRef as ReactComponent };